import { Environment } from '../common/types';
import { LoginConfig } from './authority';
import { createLoginConfig, resolveEnvironment } from './login/environmentUtils';

export interface ConfigState {
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
    };
    homeRoute: string | undefined;
    id: string | undefined;
    login: LoginConfig;
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri: string | undefined;
    environmentFromUri: Environment;
}

export const getContext = () => new URLSearchParams(window.location.search).get('context') ?? undefined;

export const isWebTMS = (): boolean => getContext() === 'webtms';

export const getMinimumDaysInFutureWhereEditingIsAllowed = (): number => (isWebTMS() ? 30 : 14);

const initialConfig = (): ConfigState => {
    const logisticsTenant = resolveEnvironment(window.location.hostname);
    const login = createLoginConfig(logisticsTenant);
    return {
        backend: {
            // biome-ignore lint/style/useNamingConvention: Custom variable
            AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
            // biome-ignore lint/style/useNamingConvention: Custom variable
            MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
        },
        homeRoute: import.meta.env.VITE_HOME_ROUTE,
        id: import.meta.env.VITE_ID,
        login: { ...login, userStore: undefined },
        serviceVersion: APP_VERSION,
        serviceEnvironment: import.meta.env.MODE,
        enableMockServer: import.meta.env.DEV,
        logoutUri: import.meta.env.VITE_LOGOUT_URI,
        environmentFromUri: logisticsTenant,
    };
};

export const config: ConfigState = initialConfig();
